<template lang="pug">
.pdf-modal
  b-modal(v-model="_value" :size="size" no-close-on-backdrop no-close-on-esc hide-footer)
    .default-modal-body(v-if="_value").text-center
      object.pdf(:data="pdfUrl" type="application/pdf")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### PDFプレビューモーダル
 */
@Component
export default class PdfModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "xl" })
  size!: string;
  /** 表示するPDFのURL。S3格納の場合は先に公開URLにしておく必要がある */
  @Prop()
  pdfUrl!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
.pdf {
  width: 100%;
  height: 83vh;
}
</style>
